import React from "react";
import "./styles/TermsOfService.css"; // ✅ Import the CSS for styling

const TermsOfService = () => {
  return (
    <div className="policy-container">
      <h1>Terms of Service</h1>
      <p>Last Updated: July 22, 2026</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to <strong>StormOps Dispatch</strong> (the “Service” or “App”).
        This Service is provided by Next Remedy (“we,” “us,” or “our”).
        These Terms of Service (“Terms”) govern your access to and use of the App,
        including any content, functionality, and services offered through it.
        By creating an account or otherwise using the Service, <strong>you agree to be
        bound by these Terms and our <a href="/privacy-policy">Privacy Policy</a></strong>.
        If you do not agree with these Terms, you must not use the App.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least <strong>18 years old</strong> to use this Service. 
        If you are using the App on behalf of a company, you represent that you have the authority
        to bind that entity to these Terms.
      </p>

      <h2>3. User Responsibilities</h2>
      <ul>
        <li>You will not publish false emergency, weather, safety, or service-availability claims.</li>
        <li>You will verify that any public customer-facing update is appropriate for your business and service area.</li>
        <li>You will not upload malware, attempt hacking, or interfere with platform security.</li>
      </ul>

      <h2>4. Services Provided</h2>
      <p>
        The App creates official-alert-backed service response runs for local operators.
        The features include:
      </p>
      <ul>
        <li><strong>Official Alert Preview</strong> - Review current National Weather Service alert context for a ZIP code.</li>
        <li><strong>Response Kit Production</strong> - Generate a customer notice, operations checklist, and service-priority plan.</li>
        <li><strong>Public Status Page</strong> - Publish a customer-facing service update after paid production completes.</li>
      </ul>

      <h2>5. Payment & Refund Policy</h2>
      <p>
        Payments are processed securely via Stripe.
        Refunds are provided only in specific cases, as outlined in the refund policy.
      </p>

      <h2>6. Data Usage & Privacy</h2>
      <p>
        Your personal information is protected under our 
        <a href="/privacy-policy"> Privacy Policy</a>.
      </p>

      <h2>7. Compliance with Google Policies</h2>
      <p>
        If you sign in using Google, you must comply with Google’s terms and API usage policies.
      </p>

      <h2>8. Contact Information</h2>
      <p>
        If you have any questions, contact us at:
        <a href="mailto:paulavictoriano@nextremedy.net">paulavictoriano@nextremedy.net</a>.
      </p>
    </div>
  );
};

export default TermsOfService;
